<template lang="pug">
v-list(dense class="truncated-folio-detail-height scrollable")
  v-text-field(
        v-model="query"
        :hint="hintMessage"
        small
        label="Para buscar ingrese tres o más caracteres")
  v-list-item-group(
    v-model="selectedAnnotation"
    color="primary")
    v-list-item(
      @click="selectAnnotation(item)"
      v-for="(item, i) in filteredAnnotations"
      :key="i")
      div(v-if="item.errors")
        v-icon(v-if="item.errors.length > 0" color="red" size="25" title="Esta anotación presenta errores") mdi-shield-alert
      annotation-badge(
        :annotation-number="item.numero"
        :number-cancellation="item.cancelacion ? item.cancelacion.numero  : 0")
      v-list-item-content
        v-list-item-title {{item.especificacion ? item.especificacion : 'ANOTACION SIN VALIDEZ'}}
      annotation-badge(
        v-if="item.cancelacion"
        :show-annotation="true"
        :annotation-number="item.cancelacion.numero")
      v-btn(
        :loading="item.id in loadingAnnotations"
        v-if="item.archivo === null"
        class="mx-2"
        fab
        dark
        x-small
        @click="showForm(item)"
        title="Cargar documento"
        color="primary")
        v-icon(dark) mdi-upload
      v-btn(
        v-else
        class="mx-2 white--text"
        fab
        color="red"
        x-small
        @click="showAnnotationDocument(item)"
        title="Ver documento")
        v-icon(dark) mdi-file-pdf-box
</template>

<script>
import { mapState, mapActions } from 'vuex';
import AnnotationBadge from '../annotations/AnnotationBadge.vue';
import { REGEX_DOCUMENT_TYPE } from '@/constants/regex'
import documentMixin from '@/mixins/documentMixin.js';

export default {
  name: 'AnnotationList',

  components: {
    AnnotationBadge,    
  },

  mixins: [documentMixin],

  props: {
    annotations: {
      type: Array,
      required: true
    }
  },

  data: () => ({
    query: '',
    filteredAnnotations: [],
    hintMessage: '',
    // estado que indica que anotaciones estan cargando
    loadingAnnotations: [],
  }),

  computed: {
    ...mapState('ui',  ['currentProperties']),
    selectedAnnotation: {
      get() {
        return this.$store.state.folios.selectedAnnotation;
      },
      set(value) {
        return this.$store.commit('folios/SELECT_ANNOTATION', value);
      }
    },
  },

  watch: {
    query(newValue) {
      if (newValue != '') {
        this.filteredAnnotations = this.annotations.filter((x) => 
          x.datos_documento.toLowerCase().includes(newValue.toLowerCase()) ||
          x.documento.toLowerCase().includes(newValue.toLowerCase()) ||
          x.especificacion.toLowerCase().includes(newValue.toLowerCase()) ||
          x.interesados.some(i => i.nombre.toLowerCase().includes(newValue.toLowerCase()) || i.numero_identificacion.toLowerCase().includes(newValue.toLowerCase())) ||
          x.codigo_especificacion.toLowerCase().includes(newValue.toLowerCase()));
        if (this.filteredAnnotations.length > 0) {
          this.hintMessage = `Se encontraron ${this.filteredAnnotations.length} resultado(s)`;
        } else {
          this.hintMessage = 'Sin resultados';
        }
        
      } else {
        this.filteredAnnotations = this.annotations;
        this.hintMessage = '';
      }
    },
    '$store.state.annotations.currentAnnotations': {
      deep: true,
      handler() {
        this.filteredAnnotations = this.annotations;
      }
    }
  },

  mounted() {
    this.filteredAnnotations = this.annotations;
  },
  
  methods: {
    ...mapActions('nlp', ['getNer']),
    selectAnnotation(annotation) {
      this.$bus.$emit('select-annotation', {
        annotation
      });
    },
    // metodo para mostrar el modal de carga de documento
    async showForm(annotation) {
      // poner a cargar anotacipn
      this.loadingAnnotations.push(annotation.id);
      this.uiChangeValue({
        varName: 'modalWidth',
        value: '50%',
      });
      this.uiChangeValue({
        varName: 'showModalOptions',
        value: false,
      });
      // extraer el numero del documento
      const matches = REGEX_DOCUMENT_TYPE.exec(annotation.documento);
      let number = '';
      let documentType = '';
      if (matches.length > 0) {
        documentType = matches[0];
        number = annotation.documento.replace(documentType, '').trim();
        if (documentType === 'RESOLUCION ADMINISTRATIVA'){
          documentType = 'RESOLUCION';
        }
        if (documentType === 'ACTA DE CONCILIACION'){
          documentType = 'ACTA';
        }
        if (documentType === 'JUICIO DE SUCESION'){
          documentType = 'SUCESION';
        }
      }
      // hacer consulta NER para la entidad que expide
      const res = await this.getNer(annotation.datos_documento);
      let entityCity = '';
      entityCity = res.ner.find((entity) => entity.label === 'CIUDAD');
      let selectedCity = null;
      if (entityCity) selectedCity = entityCity.text;
      this.uiChangeValue({
        varName: 'currentProperties',
        value: {
          annotationData: {
            entity: annotation.datos_documento,
            name: annotation.documento,
            date: annotation.fecha_doc_anotacion,
            number,
            documentType,
            selectedCity,
          },
          annotationId: annotation.id
        },
      });
      this.uiSetDialogContent('DocumentForm');
      this.uiSetDialogTitle('Cargar documento a la anotación');
      this.uiToggleDialog(true);
      // quitar carga de boton
      const index = this.loadingAnnotations.indexOf(annotation.id);
      this.loadingAnnotations.splice(index, 1);
    },
  },
  
}
</script>
